module.exports = __webpack_public_path__ + "static/media/the-usual.2c9dca5b.svg";